import { Skeleton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { CreateUserIfNoExistsAndActivateLevels } from '../../../../apis/User/indexv2';

const PaypalButton = (props: IPaypalButtonProps) => {

    const [isLoading, setIsLoading] = useState(false);

    const onCreateOrder = async () => {
        try {
            setIsLoading(true);
            const response = await fetch("https://createorder-5kg2vejuqa-uc.a.run.app", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    orderId: props.orderId
                }),
            });

            const orderData = await response.json();

            if (orderData.id) {
                return orderData.id;
            } else {
                const errorDetail = orderData?.details?.[0];
                const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                    : JSON.stringify(orderData);

                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error(error);
            // resultMessage(`Could not initiate PayPal Checkout...<br><br>${error}`);
        } finally {
            setIsLoading(false);
        }
    }

    const onApproveOrder = async (data: any, actions: any) => {
        try {
            setIsLoading(true);
            const response = await fetch(`https://captureorder-5kg2vejuqa-uc.a.run.app`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    orderId: data.orderID
                }),
            });

            const orderData = await response.json();
            // Three cases to handle:
            //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            //   (2) Other non-recoverable errors -> Show a failure message
            //   (3) Successful transaction -> Show confirmation or thank you message

            const errorDetail = orderData?.details?.[0];

            if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                return actions.restart();
            } else if (errorDetail) {
                // (2) Other non-recoverable errors -> Show a failure message
                throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
            } else if (!orderData.purchase_units) {
                throw new Error(JSON.stringify(orderData));
            } else {
                // (3) Successful transaction -> Show confirmation or thank you message
                // Or go to another URL:  actions.redirect('thank_you.html');
                if(orderData?.payer?.email_address !== undefined && orderData?.payer?.email_address !== ''){
                    try {
                        const res = await CreateUserIfNoExistsAndActivateLevels({
                            email: orderData?.payer?.email_address,
                            name: orderData?.payer?.name?.given_name || "",
                            lastname: orderData?.payer?.name?.surname || "",
                            orderId: props.orderId
                        });
                        props.onSuccess({
                            email: res.email,
                            password: res.autogeneratedPassword
                        });
                    } catch (error) {
                        props.onSuccess(undefined);
                    }

                }
                
                // const transaction =
                //     orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
                //     orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
                // // resultMessage(
                // //     `Transaction ${transaction.status}: ${transaction.id}<br><br>See console for all available details`,
                // // );
                // console.log(
                //     "Capture result",
                //     orderData,
                //     JSON.stringify(orderData, null, 2),
                // );
            }
        } catch (error) {
            setTimeout(() => {
                props.onFailure();
            });
            // resultMessage(
            //     `Sorry, your transaction could not be processed...<br><br>${error}`,
            // );
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (window as any)
            .paypal
            .Buttons({
                createOrder: onCreateOrder,
                onApprove: onApproveOrder,
                onClick: () => props.onChangeState !== undefined && props.onChangeState(true),
                onCancel: () => props.onChangeState !== undefined &&  props.onChangeState(false),
                fundingSource: (window as any).paypal.FUNDING.CARD
            })
            .render("#paypal-button-container");
    }, []);
    return (
        <Stack spacing={2}>
            <div id="paypal-button-container"></div>
            {isLoading === true && (
                <Stack spacing={1}>
                    <Skeleton animation='pulse' variant="rounded" height={30} />
                    <Skeleton animation='pulse' variant="rounded" height={30} />
                    <Skeleton animation='pulse' variant="rounded" height={30} />
                </Stack>
            )}
        </Stack>
    );
}


export { PaypalButton }